// ** React Imports
import React, { type ReactNode } from 'react';

import './scrollBox.css';

// ** Direction component for LTR or RTL
import Direction from '../layouts/components/Direction';

// ** Theme
import getThemeOptions from './getThemeOptions';

// ** Global Styles
import GlobalStyling from './globalStyles';

// ** Theme Config
import themeConfig from '../config';

// ** Type Imports
import type { Settings } from '../context/settingsContext';

// ** MUI Imports
import CssBaseline from '@mui/material/CssBaseline';
import GlobalStyles from '@mui/material/GlobalStyles';
import {
  type ThemeOptions,
  ThemeProvider,
  createTheme,
  responsiveFontSizes,
} from '@mui/material/styles';

interface Props {
  settings: Settings;
  children: ReactNode;
}

const ThemeComponent = (props: Props) => {
  // ** Props
  const { settings, children } = props;

  // ** Pass merged ThemeOptions (of core and user) to createTheme function
  let theme = createTheme(getThemeOptions(settings));

  // ** Set responsive font sizes to true
  if (themeConfig.config.responsiveFontSizes) {
    theme = responsiveFontSizes(theme);
  }

  const userThemeOptions: ThemeOptions = Object.assign({}, themeConfig.options(theme, settings));
  theme = createTheme(theme, userThemeOptions);

  return (
    <ThemeProvider theme={theme}>
      <Direction direction={settings.direction}>
        <CssBaseline />
        <GlobalStyles styles={GlobalStyling(theme)} />
        {children}
      </Direction>
    </ThemeProvider>
  );
};

export default ThemeComponent;
